module.exports = __webpack_public_path__ + "img/logo-coppa.2ed97e89.png";